// @flow
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  @media (max-width: 420px) {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const LeftPanel = styled.div`
  flex: 2;
  height: 100%;
  background-color: ${props => props.theme.colors.black};
  color: white;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: flex-end;
  @media (max-width: 420px) {
    height: auto;
    display: block;
    width: 100%;
  }
`;

export const InnerLeft = styled.div`
  padding: 30px;
  flex: 1;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 400px;
  @media (max-width: 420px) {
    padding-bottom: 0px;
  }
`;

export const VerticalCenter = styled.div``;

export const Title = styled.h1`
  font-family: ${(props: Rota$SCP) => props.theme.fontBold};
  margin-top: 0;
`;

export const FooterLink = styled(Link)`
  color: white;
  text-decoration: none;
  font-family: ${props => props.theme.fontBold};
  font-size: 16px;
  &:hover {
    text-decoration: underline;
    text-decoration-color: ${props => props.theme.colors.green};
  }
`;

export const Lead = styled.p`
  font-size: 24px;
  margin-top: 40px;
`;

export const Footer = styled.div`
  padding: 20px 30px;
  width: 100%;
  max-width: 400px;
`;

export const RightPanel = styled.div`
  height: 100%;
  flex: 3;
  display: flex;
  position: relative;
  @media (max-width: 420px) {
    height: auto;
    display: block;
    width: 100%;
  }
`;

export const InnerRight = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 100px;
  max-width: 600px;
  @media (max-width: 420px) {
    justify-content: center;

      max-width: 100%;
      padding: 50px 20px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/auth-page-layout/auth-page-layout.styles.js